import apiService from '../apiService';
const INTAKE_FORM_URL = '/intake-form';
const intakeFormService = {

  async viewIntakeForm() {
    try {
      const response = await apiService.get('/custom-form');
      return response;
    } catch (error) {
      throw error.response.data;
    }
  },

  async sendIntakeForm(payload) {
    try {
      const response = await apiService.post(`${INTAKE_FORM_URL}/send_intake_form_email`, payload);
      return response;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getContactMatterSystemFields() {
    try {
      const response = await apiService.get(`${INTAKE_FORM_URL}/get_all_fields`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async createIntakeForm(payload) {
    try {
      const response = await apiService.post(`${INTAKE_FORM_URL}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSingleForm(id) {
    try {
      const response = await apiService.get(`${INTAKE_FORM_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response;
    }
  },

  async duplicateIntakeForm(id) {
    try {
      const response = await apiService.post(`${INTAKE_FORM_URL}/${id}/duplicate`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateIntakeForm(id, payload) {
    try {
      const response = await apiService.put(`${INTAKE_FORM_URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async postIntakeForm(payload, token) {
    try {
      const response = await apiService.post(`${INTAKE_FORM_URL}/store_contact_and_matter/${token}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteIntakeForm(id) {
    try {
      const response = await apiService.delete(`${INTAKE_FORM_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response;
    }
  },

  async verifyIntakeForm(token) {
    try {
      const response = await apiService.get(`/intake-form-by-token?token=${token}`);
      return response.data;
    } catch (error) {
      throw error.response;
    }
  },

  async generateTokenForIframe(id) {
    try {
      const response = await apiService.get(`${INTAKE_FORM_URL}/generate-token?id=${id}`);
      return response.data;
    } catch (error) {
      throw error.response;
    }
  },

};

export default intakeFormService;